export const ID = '7603e11c-4f41-44f1-99c9-8d5bf7d093ad';

export const NAME = 'Hours: Facility';
